import { ActionBar, Accordion, Alert, Badge, Button, Card, Checkbox, ColorPicker, DatePicker, DetailsCard, Divider, ErrorBanner, FilePicker, Form, FormError, FormLabel, IconButton, InfoBanner, Input, Link, Listbox, Menu, Modal, NumberInput, Pagination, Progress, Radio, SearchInput, Select, Skeleton, StatusLabel, Steps, SuccessBanner, Switch, Tabs, Tag, Textarea, WarningBanner } from './components';
import { extendTheme } from '../../../theme';
import defaultTheme from '../../../theme/default-theme';
var arialSansFont = 'Arial, Helvetica, sans-serif';
var theme = extendTheme(defaultTheme, {
  name: 'PP2 Wales',
  colors: defaultTheme.colors,
  fonts: {
    heading: arialSansFont,
    body: arialSansFont
  },
  styles: {
    global: {
      body: {
        color: '#1f1f1f'
      }
    }
  },
  components: {
    ActionBar,
    Accordion,
    Alert,
    Badge,
    Button,
    Card,
    Checkbox,
    ColorPicker,
    DatePicker,
    DetailsCard,
    Divider,
    ErrorBanner,
    FilePicker,
    Form,
    FormError,
    FormLabel,
    IconButton,
    InfoBanner,
    Input,
    Link,
    Listbox,
    Menu,
    Modal,
    NumberInput,
    Pagination,
    Progress,
    Radio,
    SearchInput,
    Select,
    Skeleton,
    StatusLabel,
    Steps,
    Switch,
    SuccessBanner,
    Tabs,
    Tag,
    Textarea,
    WarningBanner
  }
});
export default theme;